import React from 'react'
import {
  ISimplifiedProps,
  IHeaderNavigationElement,
  isHeaderNavigationLink,
  getUrlWithPageviewParam,
  isHeaderNavigationSection,
} from './index'

export function HeaderNavigationSimplified({
  navigationElements = [],
}: ISimplifiedProps): React.ReactElement {
  return (
    <div
      data-testid="header-navigation-simplified"
      className="header-navigation-simplified"
      style={{ display: 'flex' }}
    >
      {navigationElements?.map((element: IHeaderNavigationElement) => {
        return (
          <>
            <div className="sections">
              <div role="menu" aria-label={element.title} className="section">
                <div className="title">
                  <span>{element.title}</span>
                </div>
                <div className="items" style={{ display: 'flex' }}>
                  {isHeaderNavigationLink(element) ? (
                    <a
                      href={getUrlWithPageviewParam(element.url)}
                      role="menuitem"
                      data-testid={`headernavigationmenu-${element.title
                        .toLowerCase()
                        .replace(/\W/g, '')}`}
                    >
                      {element.title}
                    </a>
                  ) : (
                    element.sections?.map((section) => (
                      <div
                        data-testid="header-navigation-menu-item"
                        className="item-container"
                        key={section.title}
                      >
                        {section.title}

                        {isHeaderNavigationSection(section) &&
                          section.items.map((item) => (
                            <div key={item.url}>
                              <a
                                href={item.url}
                                role="menuitem"
                                data-testid={`headernavigationmenu-${item.title
                                  .toLowerCase()
                                  .replace(/\W/g, '')}`}
                              >
                                <div className="content">
                                  <div className="title">
                                    <div className="title-text">
                                      <span>{item.title}</span>
                                    </div>
                                  </div>
                                </div>
                              </a>
                              <div>
                                <span>{item.subtitle}</span>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </>
        )
      })}
    </div>
  )
}
